import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import TriangleIcon from '../../assets/svgs/TriangleIcon';

import onlyNumbers from '../../utils/onlyNumbers';

import { InputNumberFieldStyle } from './InputNumberFieldStyle';

const InputNumberField = ({
  theme,
  shape,
  inputName,
  value,
  placeholder,
  min,
  max,
  step,
  suffix,
  error,
  disabled,
  handleChange,
}) => {
  const classNames = useMemo(() => {
    const current = [];

    if (theme?.length) {
      current.push(`${theme}-theme`);
    }

    if (shape?.length) {
      current.push(`${shape}-shape`);
    }

    if (error?.length) {
      current.push('with-error');
    }

    return current;
  }, [error?.length, shape, theme]);

  const onClickStep = (valueStep) => {
    let current = onlyNumbers(value);

    current = parseInt(current, 10);
    current += valueStep;
    if (current <= min) {
      current = min;
    }

    if (current >= max) {
      current = max;
    }
    handleChange(onlyNumbers(current));
  };

  return (
    <InputNumberFieldStyle className={classNames}>
      <div className="input-element-wrapper">
        <input
          type="text"
          className="input-number-element"
          placeholder={placeholder}
          name={inputName}
          value={value}
          disabled={disabled || !handleChange}
          min={min}
          max={max}
          step={step}
          size={value?.length || 1}
          onChange={
            handleChange
              ? (event) => handleChange(onlyNumbers(event.currentTarget.value))
              : null
          }
        />
        <button
          type="button"
          className="increase-value"
          aria-label="Increase value"
          onClick={() => onClickStep(step)}
        >
          <TriangleIcon />
        </button>
        <button
          type="button"
          className="decrease-value"
          aria-label="Decrease value"
          onClick={() => onClickStep(-step)}
        >
          <TriangleIcon />
        </button>
        {suffix?.length ? <span className="input-suffix">{suffix}</span> : null}
      </div>
      {error.length ? <p className="input-error">{error}</p> : null}
    </InputNumberFieldStyle>
  );
};

InputNumberField.propTypes = {
  theme: PropTypes.string,
  shape: PropTypes.string,
  inputName: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  placeholder: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.number]),
  step: PropTypes.number,
  suffix: PropTypes.string,
  error: PropTypes.string,
  disabled: PropTypes.bool,
  handleChange: PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.func]),
};

InputNumberField.defaultProps = {
  theme: 'default',
  shape: 'rounded',
  placeholder: '',
  min: 0,
  max: null,
  step: 1,
  suffix: '',
  error: '',
  disabled: false,
  handleChange: null,
};

export default InputNumberField;
